import { tokens } from "../../theme";
import * as React from "react";

import { saveAs } from "file-saver";

import {
  Box,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import SectionHeader from "../../components/SectionHeader";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { DataGrid } from "@mui/x-data-grid";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import {
  getFromLocalStorage,
  getFromLocalStorageJsonObject,
  saveToLocalStorageJsonObject,
} from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAtom } from "jotai";
import { isAuthPageAtom, showErrorAlertDialog } from "../../config/AppConfig";
import {
  ALERT,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  PROCESSING_PLEASE_WAIT,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
  FETCHING_PAYOUT_DETAILS_PLEASE_WAIT,
  DOWNLOADING_REPORT,
  SOME_ERROR_OCCURRED,
  LOADING_REPORT_NAMES_PLEASE_WAIT,
  ERROR,
} from "../../constants/Strings";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_ROLE,
  USER_NAME,
  SELECTED_COMPANY,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import {
  getPayoutAllTransactions,
  holdPayoutTransaction,
  payoutRequestApproval,
  getPayoutTotalHeaderSummary,
  payoutApproval,
  downloadPayoutsReports,
} from "../../services/ApiService";

import * as CONSTANT from "../../constants/Constant";
import HighlightsPrimary from "../../components/HighlightsPrimary";
import NoDataFound from "../../components/NoDataFound";
import {
  payoutAllTransactionColumnHeader,
  } from "../../components/ColumnHeader";
import CustomButton from "../../components/CustomButton";
import { formatPrice } from "../../utils/PriceFormatter";

import { getButtonVisibilityData } from "../../utils/GetButtonVisibilityAsPerLoginResponse";
import { IncentivesActionsConfirmationDialog } from "../../components/IncentivesActionsConfirmationDialog";
import { DownloadPayoutOnHoldReportNameSelectionDialog } from "../../components/DownloadPayoutOnHoldReportNameSelectionDialog";
import useAxiosHook from "../../hooks/UseAxios";

// Filter Configurations to be passed to SearchBarFilter in SectionHeader
const filterProps = [
  {
    keyValue: "Yes ID",
    displayName: "Yes ID",
    paramName: "yesId",
    isDateFilter: false,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
  {
    keyValue: "Transaction Number",
    displayName: "TRX No.",
    paramName: "transactionNo",
    isDateFilter: false,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
  {
    keyValue: "Transaction Date",
    displayName: "Date",
    paramName: "transactionDate",
    isDateFilter: true,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
  {
    keyValue: "Package Name",
    displayName: "Name",
    paramName: "packageName",
    isDateFilter: false,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
];

const PayoutsTransactionDetails = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNetworkConnectionAvailable = UseOnlineStatus();

  const navigate = useNavigate();
  const location = useLocation();
  let selectedCompany = location.state;

  const [, setAuthStatus] = useAtom(isAuthPageAtom);
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  const [payoutCompanyName, setPayoutCompanyName] = useState("");
  const [payoutHeaderSummary, setPayoutHeaderSummary] = useState([]); // Sample Data == {"totalAmount":621.3,"dealerCount":62,"transactionCount":327,"netPayoutAmount":621.3,"holdDealerCount":0,"holdTransactionCount":0,"holdAmount":0}}
  const [payoutSummary, setPayoutSummary] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  // pagination
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });
  const [pageSize, setPageSize] = useState(15);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);

  const [selectedRows, setSelectedRows] = React.useState([]);
  const [userRole, setUserRole] = useState([]);

  // State to store the extracted IDs
  const [idsArray, setIdsArray] = useState([]);
  const [companyCode, setCompanyCodeArray] = useState([]);

  // button visibility
  const [onHoldButtonVisible, setOnHoldButtonVisibility] = useState(false);
  const [downloadButtonVisible, setDownloadButton] = useState(false);
  const [requestApprovalButtonVisibility, setRequestApprovalButton] =
    useState(false);
  const [approvelButtonVisibility, setApproveButton] = useState(false);
  const [commentButtonVisibility, setComment] = useState(false);

  // actions confirmation dialog
  const [dialogOpen, setDialogOpen] = useState(false);
  const [clickedButtonType, setClickedButtonType] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");
  const [downloadFileDialogOpen, setDownloadFileDialogOpen] = useState(false);
  const [batchNo, setBatchNo] = useState("");
  const { data, error, showProgressBar, fetchData } = useAxiosHook();
  const [reportNameOptions, setReportNameOptions] = useState([]);
  const [reportNamesValue, setReportNamesValue] = useState([]);
  const [downloadType, setDownloadType] = useState("");

  // filter and search
  const [selectedFilter, setSelectedFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  // sort model
  const [sortModel, setSortModel] = useState([]);

  // sorting handling 
  useEffect(() => {
    checkSelectedCompany()
    getTransactions(
      selectedCompany?.batchNo, 
      selectedCompany?.commissionType, 
      selectedCompany?.transactionType,
      selectedCompany?.companyCode,
      paginationModel.page, 
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  }, [sortModel]);

  useEffect(() => {
    if (showProgressBar) {
      setProgressbarText(LOADING_REPORT_NAMES_PLEASE_WAIT);
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBar]);

  useEffect(() => {
    if (error) {
      if (
        error.message !== null &&
        error.message !== undefined &&
        error.message === ApiErrorCode.NETWORK_ERROR
      ) {
        showErrorAlert(ERROR, error.message);
      } else if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
        alert(error.data.displayErrorMessage);
        navigate(CONSTANT.LOGIN);
      } else {
        const message =
          error.data !== null ? error.data.displayErrorMessage : error.message;
        showErrorAlert(
          ERROR,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      }
    }
  }, [error]);

  function getReportNamesFromApi(batchNo) {
    try {
      const requestObject = {
        batchNo: batchNo,
      };

      initializeEncryption(
        requestObject,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.GET_REPORT_NAMES_LIST
      ).then((encryptedContentData) => {
        fetchData(
          process.env.REACT_APP_REPORT_NAMES_API_URL,
          ApiType.GET_REPORT_NAMES_LIST,
          ApiType.POST_METHOD,
          encryptedContentData,
          {},
          (data) => {
            if (data !== null) {
              if (data.result.reportNames.length > 0) {
                setReportNameOptions(
                  data.result.reportNames.map((item) => item.reportName)
                );
                setReportNamesValue(data.result.reportNames);
              } else {
                showErrorAlert(ALERT, CONSTANT.ERROR_IN_LOADING_REPORT_NAMES);
              }
            }
          }
        );
      });
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  const getReportName = (type) => {
    setDownloadType(type);
    getReportNamesFromApi(batchNo);
  };

  useEffect(() => {
    if (reportNameOptions.length > 0) {
      openDownloadOptionsDialog(downloadType);
    }
  }, [reportNameOptions]);

  function checkSelectedCompany() {
    // If selectedCompany is not in the location state (e.g., after a page refresh),
    // try to retrieve it from localStorage
    if (!selectedCompany) {
      const storedData = getFromLocalStorageJsonObject(
        SELECTED_COMPANY,
        JSON.stringify(selectedCompany)
      );
      selectedCompany = storedData ? JSON.parse(storedData) : null;
    } else {
      // If payoutRowSelected is in the location state, store it in localStorage
      saveToLocalStorageJsonObject(
        SELECTED_COMPANY,
        JSON.stringify(selectedCompany)
      );
    }
  }

  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });
    checkSelectedCompany();

    getTransactions(
      selectedCompany?.batchNo,
      selectedCompany?.commissionType,
      selectedCompany?.transactionType,
      selectedCompany?.companyCode,
      newPage,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  };

  const handlePageChange = (newPage) => {
    DebugLog("handlePageChange data: " + selectedCompany);
    setPaginationModel({ pageSize: pageSize, page: newPage });
    checkSelectedCompany();

    getTransactions(
      selectedCompany?.batchNo,
      selectedCompany?.commissionType,
      selectedCompany?.transactionType,
      selectedCompany?.companyCode,
      newPage,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  };

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });
    checkSelectedCompany();

    // call api with new page size and start from page 0.
    getTransactions(
      selectedCompany?.batchNo,
      selectedCompany?.commissionType,
      selectedCompany?.transactionType,
      selectedCompany?.companyCode,
      0,
      newPageSize,
      selectedFilter,
      searchQuery
    );
  };

  function getUserRole() {
    setUserRole(getFromLocalStorage(USER_ROLE));
  }

  useEffect(() => {
    getUserRole();
    checkSelectedCompany();
    updateButtonVisibility();

    setPayoutCompanyName(selectedCompany.displayName);
    setBatchNo(selectedCompany?.batchNo);
    if (
      selectedCompany?.batchNo &&
      selectedCompany?.commissionType &&
      selectedCompany?.companyCode
    ) {
      requestApi(
        selectedCompany.batchNo,
        selectedCompany.commissionType,
        selectedCompany.transactionType,
        selectedCompany.companyCode
      );
    }

    // get all Payout transaction details
    // getPayoutAllTransactionDetail();
  }, []);

  async function requestApi(
    batchNo,
    commissionType,
    transactionType,
    companyCode
  ) {
    // setProgressbarText(FETCHING_PAYOUT_DETAILS_PLEASE_WAIT);
    // setLoading(true);

    try {
      // await Promise.all([
      //   getTotalHeaderSummary(batchNo, companyCode),
      //   getTransactions(batchNo, commissionType, transactionType, companyCode, paginationModel.page, paginationModel.pageSize)
      //   // getTransTypeDealerBreakdown(batchNo, commissionType, transactionType, paginationModel.page, paginationModel.pageSize)
      // ]);

      getTotalHeaderSummary(batchNo, transactionType, companyCode);
      getTransactions(
        batchNo,
        commissionType,
        transactionType,
        companyCode,
        paginationModel.page,
        paginationModel.pageSize,
        selectedFilter,
        searchQuery
      );
    } catch (error) {
      handleError(error);
    }

    // setLoading(false);
  }

  useEffect(() => {
    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, rowsPerPage]);

  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  /**** Check Visibility ********/
  const updateButtonVisibility = () => {
    const actionButtonList = getButtonVisibilityData("Incentive", "Payout");
    if (actionButtonList) {
      actionButtonList.forEach((items, index) => {
        // HOLD, DOWNLOAD, APPROVE, VIEW, REQUEST APPROVAL
        if (items.buttonName === "DOWNLOAD") {
          setDownloadButton(true);
        } else if (
          items.buttonName === "REQUEST APPROVAL" &&
          selectedCompany?.showRequestApproval
        ) {
          setRequestApprovalButton(true);
        } else if (
          items.buttonName === "APPROVE" &&
          selectedCompany?.showApproval
        ) {
          setApproveButton(true);
        } else if (items.buttonName === "HOLD" && selectedCompany?.showHold) {
          setOnHoldButtonVisibility(true);
        }
      });
    }
  };

  /******* Confirmation Dialog Methods ***********/
  const handleDialogOpen = (type) => {
     // check selected data
     const selectedData = payoutSummary.filter((row) =>
      selectedRows.includes(row.id)
    );
    if (selectedData.length <= 0) {
      showErrorAlert("Alert", "Please choose some rows first!");
    } else {
      let title = "";
      if (type === "Hold") {
        title = "Hold";
      } else if (type === "Approve") {
        title = "Approve";
      } else if (type === "Request Approval") {
        title = "Request Approval";
      }
      setClickedButtonType(type);
      setDialogTitle(title);
      setDialogOpen(true);
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleSubmit = (file, comment, type, selectedDate) => {
    dialogResponseRecieved(file, comment, type, selectedDate);
  };

  const dialogResponseRecieved = (file, comment, type, selectedDate) => {
    // get the batch no and version code which is the same for all data in the same page
    checkSelectedCompany();
    const extractBatchNo = selectedCompany?.batchNo;
    const extractVersionCode = selectedCompany?.version;
    const extractedTransactionType = selectedCompany?.transactionType;
    const extractedCompanyCode = selectedCompany?.companyCode;

    // check selected data
    const selectedData = payoutSummary.filter((row) =>
      selectedRows.includes(row.id)
    );

    // check if there is attachment and set accordingly
    let fileNameWithoutExtension = null;
    if (file) {
      fileNameWithoutExtension = file.name.split(".").slice(0, -1).join(".");
    }

    let contentData = {};

    switch (type) {
      case "Hold":
        let idsArray = [];
        selectedData.forEach((element) => {
          idsArray.push(element.id);
        });

        if (file) {
          readFileAsBase64(file)
            .then((base64String) => {
              contentData = {
                batchNo: extractBatchNo,
                version: extractVersionCode,
                transactionType: extractedTransactionType,
                companyCode: extractedCompanyCode,
                remark: comment,
                ids: idsArray,
                fileName: fileNameWithoutExtension,
                fileType: file.type,
              };

              requestPayoutTransactionOnHold(contentData, base64String);
            })
            .catch((error) => {
              console.error("Error reading file:", error);
            });
        } else {
          contentData = {
            batchNo: extractBatchNo,
            version: extractVersionCode,
            transactionType: extractedTransactionType,
            companyCode: extractedCompanyCode,
            remark: comment,
            ids: idsArray,
          };

          requestPayoutTransactionOnHold(contentData);
        }

        break;

      case "Request Approval":
        if (file) {
          readFileAsBase64(file)
            .then((base64String) => {
              contentData = {
                batchNo: extractBatchNo,
                version: extractVersionCode,
                remark: comment,
                fileName: fileNameWithoutExtension,
                fileType: file.type,
              };

              payoutRequestApprovalApi(contentData, base64String);
            })
            .catch((error) => {
              console.error("Error reading file:", error);
            });
        } else {
          contentData = {
            batchNo: extractBatchNo,
            version: extractVersionCode,
            remark: comment,
          };

          payoutRequestApprovalApi(contentData);
        }

        break;

      case "Approve":
        if (file) {
          readFileAsBase64(file)
            .then((base64String) => {
              contentData = {
                batchNo: extractBatchNo,
                version: extractVersionCode,
                remark: comment,
                selectedDate: selectedDate,
                fileName: fileNameWithoutExtension,
                fileType: file.type,
              };

              callApprovePayoutAPI(contentData, base64String);
            })
            .catch((error) => {
              console.error("Error reading file:", error);
            });
        } else {
          contentData = {
            batchNo: extractBatchNo,
            version: extractVersionCode,
            remark: comment,
            selectedDate: selectedDate,
          };

          callApprovePayoutAPI(contentData);
        }
        break;

      default:
        showErrorAlert("Error", "Invalid action type!");
    }
  };

  function readFileAsBase64(file) {
    return new Promise((resolve, reject) => {
      if (!file) {
        reject("No file provided");
      }

      const reader = new FileReader();
      reader.onload = function (event) {
        // event.target.result contains the base64 string
        // We need to extract the base64 part from the Data URL
        const base64String = event.target.result.split(",")[1];
        resolve(base64String);
      };
      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  }

  /***** API Calls ******/

  async function getTotalHeaderSummary(
    receivedBatchNo,
    receivedTransactionType,
    receivedCompanyCode
  ) {
    try {
      if (!isNetworkConnectionAvailable) {
        throw new Error(NO_INTERNET_CONNECTION_FOUND);
      }
      setProgressbarText(FETCHING_PAYOUT_DETAILS_PLEASE_WAIT);
      setLoading(true); // Hide the progress dialog

      const contentData = {
        batchNo: receivedBatchNo,
        transactionType: receivedTransactionType,
        companyCode: receivedCompanyCode,
      };

      const encryptedContentData = await initializeEncryption(
        contentData,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.PAYOUT_TOTAL_HEADER_SUMMARY
      );

      const payoutSummaryRequestData = {
        requestId: generateRequestId(),
        loginId: getFromLocalStorage(LOGIN_ID),
        sessionId: getFromLocalStorage(SESSION_ID),
        loginUserName: getFromLocalStorage(USER_NAME),
        contentData: encryptedContentData,
      };

      getPayoutTotalHeaderSummary(payoutSummaryRequestData)
        .then((response) => {
          setPayoutHeaderSummary(response.data.result);
          setLoading(false);
        })
        .catch((error) => {
          handleError(error);
        });
    } catch (error) {
      handleError(error);
    }
  }

  async function getTransactions(
    receivedBatchNo,
    commissionType,
    transactionType,
    companyCode,
    pageNo,
    pageSize,
    selectedFilter,
    searchQuery
  ) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

        const contentData = createRequestObject(
          receivedBatchNo,
          commissionType,
          transactionType,
          companyCode,
          pageNo,
          pageSize,
          selectedFilter,
          searchQuery
        );

        const encryptedContentData = await initializeEncryption(
          contentData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_PAYOUT_SUMMARY_DEALER
        );

        const payoutSummaryRequestData = {
          requestId: generateRequestId(),
          loginId: getFromLocalStorage(LOGIN_ID),
          sessionId: getFromLocalStorage(SESSION_ID),
          loginUserName: getFromLocalStorage(USER_NAME),
          contentData: encryptedContentData,
        };

        getPayoutAllTransactions(payoutSummaryRequestData)
          .then((response) => {
            setPayoutSummary(response.data.result.content);
            setRowsPerPage(response.data.result.content.length);
            setTotalNoOfRows(response.data.result.totalElements);
            setTotalNoOfPages(response.data.result.totalPages);

            setLoading(false);
            DebugLog(
              "getPayoutAllTransactions response.data=====" +
                JSON.stringify(response.data)
            );
          })
          .catch((error) => {
            handleError(error);
          });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }
  // Create Request Object for getTransTypeDealerBreakdown API
  function createRequestObject(
    receivedBatchNo,
    commissionType,
    transactionType,
    companyCode,
    pageNumber,
    pageSize,
    selectedFilter,
    filterValue
  ) {
    // Initialize all fields to null
    let requestObject = {
      batchNo: receivedBatchNo,
      commissionType: commissionType,
      transactionType: transactionType,
      companyCode: companyCode,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };

    // Set the appropriate field based on filterCriteria
    if (
      selectedFilter != null &&
      selectedFilter != undefined &&
      selectedFilter != "" &&
      selectedFilter.paramName != ""
    ) {
      if (
        filterValue != null &&
        filterValue != undefined &&
        filterValue != ""
      ) {
        requestObject[selectedFilter] = filterValue;
      }
    }

    // sorting
  try{
      if (sortModel.length > 0) {
        // set sortProperty according to the field
        switch (sortModel[0].field) {
          case "yesId":
            requestObject.sortProperty = "YES_ID";
            break;
          case "transactionNo":
            requestObject.sortProperty = "TRANSACTION_NO";
            break;
          case "transactionType":
            requestObject.sortProperty = "TRANSACTION_TYPE";
            break;
          case "transactionDate":
            requestObject.sortProperty = "TRANSACTION_DATE";
            break;
          case "planName":
            requestObject.sortProperty = "PLAN_NAME";
            break;
          default:
            break;
        }
        // set the sort order
        requestObject.sortOrder = sortModel[0].sort.toString().toUpperCase();
      } 
    } catch (error) {
      DebugLog("Error in sorting: " + error);
      requestObject.sortProperty = null;
      requestObject.sortOrder = null;
    }

    return requestObject;
  }

  async function requestPayoutTransactionOnHold(contentData,fileContentBase64String) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

        const encryptedContentData = await initializeEncryption(
          contentData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.HOLD_PAYOUT_TRANSACTIONS
        );

        const requestData = {
          requestId: generateRequestId(),
          loginId: getFromLocalStorage(LOGIN_ID),
          sessionId: getFromLocalStorage(SESSION_ID),
          contentData: encryptedContentData,
          fileContent: fileContentBase64String,
        };

        holdPayoutTransaction(requestData)
          .then((response) => {
            if (response.data.responseCode === "0") {
              navigate("/PayoutsActionItemsSuccess", {
                state: { data: response.data.result, type: 1 },
              });
            }

            resetSelection();
            setLoading(false);
          })
          .catch((error) => {
            handleError(error);
          });
      }
    } catch (error) {
      handleError(error);
    }
  }

  async function payoutRequestApprovalApi(
    requestData,
    fileContentBase64String
  ) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

        initializeEncryption(
          requestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.REQUEST_APPROVAL_PAYOUT
        ).then((encryptedContentData) => {
          const payoutRequestApprovalData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
            fileContent: fileContentBase64String,
          };

          payoutRequestApproval(payoutRequestApprovalData)
            .then((response) => {
              setLoading(false);
              resetSelection();

              if (response.data.responseCode === "0") {
                navigate("/PayoutsActionItemsSuccess", {
                  state: { data: response.data.result, type: 2 },
                });
              }
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  async function callApprovePayoutAPI(contentData, fileContentBase64String) {
    try {
      if (!isNetworkConnectionAvailable) {
        throw new Error(NO_INTERNET_CONNECTION_FOUND);
      }

      setProgressbarText(PROCESSING_PLEASE_WAIT);
      setLoading(true);

      const encryptedContentData = await initializeEncryption(
        contentData,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.APPROVE_PAYOUT
      );

      const requestData = {
        requestId: generateRequestId(),
        loginId: getFromLocalStorage(LOGIN_ID),
        sessionId: getFromLocalStorage(SESSION_ID),
        loginUserName: getFromLocalStorage(USER_NAME),
        contentData: encryptedContentData,
        fileContent: fileContentBase64String,
      };

      payoutApproval(requestData)
        .then((response) => {
          setLoading(false);

          if (response.data.responseCode === "0") {
            navigate("/PayoutsActionItemsSuccess", {
              state: { data: response.data.result, type: 0 },
            });
          }
        })
        .catch((error) => {
          handleError(error);
        });
    } catch (error) {
      handleError(error);
    }
  }

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  const startDownload = (fileType) => {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(DOWNLOADING_REPORT);
        setLoading(true);

        checkSelectedCompany();
        const requestObject = {
          // fromDate: params.fromDate,
          // toDate: params.toDate,
          // accountCode: params.code,
          // accountName: params.name,
          // reason: params.reason,

          reportTemplate: "PAYOUT_REPORT",
          reportFormat: fileType,
          batchId: selectedCompany.batchNo,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.EARMARK_REPORT_DOWNLOAD
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          downloadPayoutsReports(requestData)
            .then((response) => {
              setLoading(false);

              let blob;
              const currentDate = new Date();
              const day = String(currentDate.getDate()).padStart(2, "0");
              const month = String(currentDate.getMonth() + 1).padStart(2, "0");
              const year = String(currentDate.getFullYear());

              // let filename be "EarmarkReport_YYYY-MM-DD"
              let filename = `PayoutsReport_${year}-${month}-${day}`;
              switch (fileType) {
                case "CSV":
                  blob = new Blob([response.data], { type: "text/csv" });
                  filename = filename + ".csv";
                  break;
                case "XLS":
                  blob = new Blob([response.data], {
                    type: "application/vnd.ms-excel",
                  });
                  filename = filename + ".xls";
                  break;
                case "PDF":
                  blob = new Blob([response.data], { type: "application/pdf" });
                  filename = filename + ".pdf";
                  break;

                default:
                  throw new Error("Invalid file type");
              }

              // Use FileSaver to save the file
              saveAs(blob, filename);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const resetSelection = () => {
    setSelectedRows([]);
  };

  // Search Bar Filter search handler
  const handleSearch = (filterParam, searchQuery) => {
    setSelectedFilter(filterParam);
    setSearchQuery(searchQuery);

    setPaginationModel({ pageSize: pageSize, page: 0 });
    checkSelectedCompany();

    getTransactions(
      selectedCompany?.batchNo,
      selectedCompany?.commissionType,
      selectedCompany?.transactionType,
      selectedCompany?.companyCode,
      0,
      paginationModel.pageSize,
      filterParam,
      searchQuery
    );
  };

  // handle error code reusable block
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    }

    const errorCode = error.data?.errorCode;
    var errorMessage =
      error.data != null ? error.data.displayErrorMessage : SOME_ERROR_OCCURRED;

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      [ApiErrorCode.UNABLE_TO_PROCESS_ERROR]: () =>
        navigate(CONSTANT.FINANCE_DASHBOARD),
      default: () =>
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
        ),
    };

    (errorActions[errorCode] || errorActions.default)();
  }
  const openDownloadOptionsDialog = (type) => {
    if (isNetworkConnectionAvailable) {
      //if(selectedRows.length===1){
      let title = "";
      if (type === "Download") {
        title = "Download";
      }
      setClickedButtonType(type);
      setDialogTitle(title);
      setDownloadFileDialogOpen(true);
      // }else{
      // showErrorAlert(ALERT,"Please choose only one row!")
      // alert("Please choose only one row!")
      // }
    } else {
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
    }
  };

  const handleFileDownloadSubmit = (fileType, type, startDate, endDate) => {
    // downloadWithholdingReport(fileType, startDate, endDate);
  };

  const handleFileDownloadDialogClose = () => {
    setDownloadFileDialogOpen(false);
  };
  function showErrorAlert(title, content) {
    try {
      DebugLog("error.data=====" + content);
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  function showErrorAlert(title, content) {
    try {
      DebugLog("error.data=====" + content);
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        <DownloadPayoutOnHoldReportNameSelectionDialog
          open={downloadFileDialogOpen}
          handleClose={handleFileDownloadDialogClose}
          handleSubmit={handleFileDownloadSubmit}
          batchNo={batchNo}
          type={clickedButtonType}
          title={dialogTitle}
          reportNameOption={reportNameOptions}
          reportNamesList={reportNamesValue}
        />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}

        {/* Greetings Header */}

        {/* Header */}
        <Grid container direction={"row"} alignItems={"center"} mb={2} ml={2}>
          <Grid item mr={2}>
            <IconButton href={CONSTANT.PAYOUT_DEALER_BREAKDOWN} width={12}>
              <img src={"../../assets/common/Back.svg"} width={12} />
            </IconButton>
          </Grid>
          <Grid item>
            <Typography
              color={colors.grey[100]}
              fontWeight={"600"}
              variant="h3"
            >
              {payoutCompanyName}
            </Typography>
          </Grid>
        </Grid>
        {/* Header */}

        {/* <GreetingHeader 
        
        greeting={navData.payoutCycle}>
          route={CONSTANT.ON_HOLD_ROUTE}
      </GreetingHeader> */}

        {/* Greetings Header */}

        {/* Highlights Section */}

        <HighlightsPrimary
          highlightTotal={"RM " + formatPrice(payoutHeaderSummary.totalAmount)}
          highlightPayOut={
            "RM " + formatPrice(payoutHeaderSummary.netPayoutAmount)
          }
          payoutDealers={payoutHeaderSummary.dealerCount}
          payoutTransactions={payoutHeaderSummary.transactionCount}
          onHold={"RM " + formatPrice(payoutHeaderSummary.holdAmount)}
          onHoldDealers={payoutHeaderSummary.holdDealerCount}
          onHoldTransactions={payoutHeaderSummary.holdTransactionCount}
        ></HighlightsPrimary>

        {/* <HighlightsSecondary
          highlightTotal={"660,200"}
          highlightTotal2={"560,000"}
          prepaidAmount={"RM 100,200"}
          prepaidAmount2={"RM 54,200"}
          postpaidAmount={"RM 560,000"}
          postpaidAmount2={"RM 185,600"}
        ></HighlightsSecondary> */}

        {/* Highlights Section */}

        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Greetings Header */}
          {/* <Grid container>
        <Grid item>
          <GreetingHeader name={"Payouts"}></GreetingHeader>
        </Grid>
      </Grid> */}
          {/* Greetings Header */}

          {/* Validations Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={2}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={0}
          >
            <SectionHeader
              sectionIcon={"../../assets/common/Payouts.svg"}
              sectionHeading={"Transactions"}
              isSearchBarEnabled={true}
              filterProps={filterProps}
              onSearch={handleSearch}
            ></SectionHeader>

            {/* <SimpleTable
          statusData={"In Validation"}
          statusBG={colors.primary[300]}
          data={payoutSummary}
        ></SimpleTable> */}

            {payoutSummary.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[600],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  classes={{ row: "dataGridRow" }}
                  rows={payoutSummary}
                  columns={payoutAllTransactionColumnHeader}
                  checkboxSelection
                  onSelectionModelChange={handleSelectionChange}
                  selectionModel={selectedRows}
                  selection // Disable row selection on row click
                  pageSize={pageSize}
                  rowCount={totalNoOfRows}
                  paginationModel={paginationModel}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[15, 30, 45, 60]}
                  autoHeight // Adjusts the height of the grid to fit its content
                  useResizeContainer

                  sortModel={sortModel}
                  onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                />
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>

          {payoutSummary.length > 0 ? (
            <Box item mt={2} ml={1}>
              <Typography>
                <span>Jump to page: </span>
                <select
                  value={paginationModel.page + 1}
                  onChange={handlePageJump}
                >
                  {[...Array(totalNoOfPages)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}

          {/* Validations Section */}
        </Grid>

        {/* Confirmation Dialog */}
        <IncentivesActionsConfirmationDialog
          open={dialogOpen}
          handleClose={handleDialogClose}
          handleSubmit={handleSubmit}
          type={clickedButtonType}
          title={dialogTitle}
        />
        {/* Confirmation Dialog */}

        {/* Action Buttons */}

        {payoutSummary.length > 0 ? (
          <Grid item mt={1} justifyContent={"flex-start"} pb={20} mr={10}>
            <Stack direction="row" spacing={2} justifyContent={"flex-end"}>
              {commentButtonVisibility ? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  // btnStartIcon={
                  //   <img src="../../assets/common/Cross.svg" width={22} />
                  // }
                  btnTxt={"Comment"}
                ></CustomButton>
              ) : (
                ""
              )}

              {onHoldButtonVisible ? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnStartIcon={
                    <img
                      src="../../assets/common/on_hold_button_icon.png"
                      width={22}
                    />
                  }
                  btnTxt={"Hold"}
                  onClick={() => handleDialogOpen("Hold")}
                ></CustomButton>
              ) : (
                ""
              )}

              {/* {downloadButtonVisible ? (
                <DownloadDropdownButton
                  onFileTypeSelected={downloadOnHoldDetails}
                />
              ) : (
                ""
              )} */}
              {downloadButtonVisible ? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnStartIcon={
                    <img src="../../assets/common/Download.svg" width={22} />
                  }
                  btnTxt={"Download"}
                  onClick={() => getReportName("Download")}
                ></CustomButton>
              ) : (
                ""
              )}

              {requestApprovalButtonVisibility ? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnStartIcon={
                    <img
                      src="../../assets/common/approve_button_icon.png"
                      width={22}
                    />
                  }
                  btnTxt={"Request Approval"}
                  onClick={() => handleDialogOpen("Request Approval")}
                ></CustomButton>
              ) : (
                ""
              )}

              {approvelButtonVisibility ? (
                <CustomButton
                  btnBG={colors.redAccent[200]}
                  btnColor={colors.grey[900]}
                  btnStartIcon={
                    <img
                      src="../../assets/common/approve_icon.svg"
                      width={22}
                    />
                  }
                  btnTxt={"Approve"}
                  onClick={() => handleDialogOpen("Approve")}
                ></CustomButton>
              ) : (
                ""
              )}
            </Stack>
          </Grid>
        ) : (
          ""
        )}

        {/* Action Buttons */}
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
};

export default PayoutsTransactionDetails;
